import React from 'react';
import AboutUsSection from './unit-section';
import OwnerAndFinancing from './ownerAndFinancing';
import ContactCardPanel from '../contact-card-panel';
import Linklist from '../../Linklist';

const Unit = (props) => {
  const matomoTrackingClass = 'om-oss';
  return (
    <div className="unit">
      {props.Description && (
        <AboutUsSection
          Content={props.Description}
          PhotoUrl={props.PhotoUrl}
          PhotoAlt={props.PhotoAltText}
          FullWidth={props.FullWidth}
        />
      )}
      {props.OwnerAndFinancing && <AboutUsSection>
        <OwnerAndFinancing {...props} />
      </AboutUsSection>}
      {(props.Offers || props.GeneralText || props.GeneralFiles) && (
        <ContactCardPanel
          subheading={true}
          hasH3={true}
          contactCardHeading="Det här kan du få hjälp med"
          Modifiers={{ 'unit__contact-card': true }}
        >
          {props.GeneralText && (
            <div
              className="offering__general-text"
              dangerouslySetInnerHTML={{ __html: props.GeneralText }}
            />
          )}
          {props.GeneralFiles && <Linklist Links={props.GeneralFiles} />}
          {props.Offers && (
            <ul className="offering__list">
              {props.Offers?.map((offer, index) => (
                <li key={`${index}--${offer.Title}`}>
                  <ContactCardPanel
                    subheading={true}
                    hasH4={true}
                    contactCardHeading={offer.Title}
                    Modifiers={{ 'contact-card--sublevel': true }}
                    matomoTrackingClass={matomoTrackingClass}
                  >
                    <div dangerouslySetInnerHTML={{ __html: offer.Text }} />
                    {offer.Files && <Linklist Links={offer.Files} />}
                  </ContactCardPanel>
                </li>
              ))}
            </ul>
          )}
        </ContactCardPanel>
      )}
    </div>
  );
};
export default Unit;
